/** @deprecated */
export enum DeprecatedCompanySizes {
  JUST_ME = 'Only me',
  LESS_THAN_TWENTY = '2-19',
  MORE_THAN_TWENTY = '20+',
}

export const companySizes = {
  0: undefined,
  1: '1',
  10: '2-30',
  50: '31-99',
  300: '100-499',
  500: '500+',
} as const;

export type CompanySizes = 0 | 1 | 10 | 50 | 300 | 500;

export const companyIndustries = {
  agency: 'Agency',
  consultancy: 'Consultancy',
  software: 'Software company',
  financial: 'Financial Services',
  construction: 'Construction',
  commerce: 'Commerce',
  education: 'Education',
  student: 'Student',
  other: 'Other',
} as const;

export type CompanyIndustries = keyof typeof companyIndustries;

export enum EstimatedCompanySizes {
  FREELANCER = 'Only me',
  TINY = '1-10',
  XSMALL = '10-50',
  SMALL = '50-250',
  MEDIUM = '250-1,000',
  LARGE = '1,000-5,000',
  XLARGE = '5,000-10,000',
  XXLARGE = '10,000-50,000',
  HUGE = '50,000-100,000',
  GIANT = '100,000+',
}

export enum PlanNames {
  ESSENTIAL = 'Essential',
  ENTERPRISE = 'Enterprise',
  COMPANY = 'Company',
  SOLO = 'Solo',
}

export enum PlanCodes {
  ESSENTIAL_YEARLY = 'essential_yearly',
  ESSENTIAL = 'essential',
  ENTERPRISE = 'enterprise',
  COMPANY = 'company',
}

/** Add-on plan codes, as in Rails' `db/plans.json`. */
export enum AddOnCodes {
  Tasks = 'timely_tasks',
  TasksYearly = 'timely_tasks_yearly',
  TasksV2 = 'timely_tasks_v2',
  TasksV2Yearly = 'timely_tasks_v2_yearly',
}

export type BillingCycle = 'monthly' | 'yearly';
